import styled from 'styled-components'
import { Alert, Descriptions, Progress } from 'antd'
import { ProgressProps } from 'antd/lib/progress'

const WrapAlert = styled(Alert)`
  margin-top: 12px;
`

const WrapDescriptions = styled(Descriptions)`
  margin-bottom: 24px;
`

const WrapProgress = styled(Progress)<ProgressProps>`
  margin-bottom: 24px;
  margin-top: 24px;
`

export { WrapAlert, WrapDescriptions, WrapProgress }
